
<template>
  <div>
    <v-subheader>Obrigatoriedade de comentário</v-subheader>
    <v-sheet class="ml-2" max-width="1000" >
      <v-slide-group mandatory v-model="newItem.comment_kind" center-active>
        <v-slide-item :value="kind.kind" v-for="(kind,idx) in comment_options" :key="'ckind6'+idx" v-slot:default="{ active, toggle }">
          <v-btn class="mx-2" depressed rounded :input-value="active" @click="toggle" 
            active-class="secondary darken-1 white--text"
          >
            <v-icon left>{{kind.icon}}</v-icon>{{kind.name}}
          </v-btn>
        </v-slide-item>
      </v-slide-group>
    </v-sheet>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  data() {
    return {
      newItem: this.$attrs.newItem,
      allComments: [
        {name: 'Não', kind: false, icon:'mdi-close'},
        {name: 'Sim', kind: true, icon:'mdi-check'},
      ],

      options_to_flow: [
        {name: 'Para inconformidades', kind: 'required_not_ok', icon:'mdi-close-outline'},
        {name: 'Para conformidades', kind: 'required_ok', icon:'mdi-check-outline'},
        {name: 'Opcional', kind: 'optional', icon:'mdi-selection-ellipse-arrow-inside'},
      ]
      // { required_ok: 10, required_not_ok: 20, optional: 30 }

    }
  },
  methods: {
    names() {
      
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    comment_options() {
      if (this.one_flow.id){
        return this.options_to_flow
      } else {
        return this.allComments
      }
    },
    ...mapState({
      one_flow: state => state.ConfigFlow.one_flow,
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>